import TCreateEditFaq from "types/Faq/createEditFaq";

const faqItemMapper = (formValues: any): TCreateEditFaq => ({
  question: formValues.question,
  answer: formValues.answer,
  order: Number(formValues.order),
});

export default faqItemMapper;
